export default __webpack_public_path__ + "static/media/the-movie-db-large.303ececb.svg";